import { post } from "src/api/trade-name";

export const useTradeNameStore = defineStore("trade-name", () => {
  const postTradeName = async (tradeName) => {
    try {
      const response = await post(tradeName);

      return response;
    } catch (error) {
      console.error(error);
    }
  };

  return {
    postTradeName,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTradeNameStore, import.meta.hot));
}
